import { Navigate, Route, Routes } from 'react-router-dom';
import LiveInterview from '../pages/LiveInterview';
import Mentor from 'src/pages/Mentor';
import Profile from 'src/pages/profile/Profile';
import MentorProfile from 'src/pages/MentorProfile';
import ShowSampleAssessment from 'src/pages/SampleAssessment';
import PreScreeningDetails from 'src/pages/PreScreeningDetails';
import MentorScreenings from 'src/pages/MentorScreenings';
import Job from 'src/pages/Job';
import LinkedInEmptyPage from 'src/pages/LinkedInEmptyPage';
import LinkedinOpenAuth from 'src/pages/LinkedinOpenAuth';
import AlumniConnect from '../pages/AlumniConnect';
import LiveSession from 'src/pages/LiveSession';

const MentorRoutes = () => {
	return (
		<Routes>
			<Route path="/linkedin-auth" element={<LinkedinOpenAuth />} />
			<Route path="/linkedin" element={<LinkedInEmptyPage />} />
			<Route path="/mentors/interviews" element={<Mentor />} />
			<Route path="/mentors/sessions" element={<AlumniConnect />} />
			<Route path="/hosts/sessions/live/:sessionId" element={<LiveSession />} />
			<Route path="/mentor/:mentorHandler" element={<MentorProfile />} />
			<Route path="/mentors/interviews/live/:id" element={<LiveInterview />} />

			<Route path="/job/:jobId" element={<Job />} />

			<Route path="/profile/:userHandler" element={<Profile />} />

			<Route path="/sample-assessment/:id" element={<ShowSampleAssessment />} />

			<Route path="/pre-screening-details/:userId" element={<PreScreeningDetails />} />

			{/* <Route path="/mentors/screenings" element={<MentorScreenings />} /> */}

			<Route path="*" element={<Navigate to="/mentors/interviews" />} />
		</Routes>
	);
};

export default MentorRoutes;
